import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import wrap from 'wraptile';
import {Select, MenuItem} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import {getTargetAgeOptionsAction} from '@pluto/target-age/Redux/TargetAgeAction';
import {selectTargetAge} from '@pluto/target-age/Redux/TargetAgeSelector';
import {DispatchAny} from '@pluto/@types';
import {TargetAgeCountryItem} from './TargetAgeTypes';
import './targetAge.scss';

export interface TargetAgeSelectProps {
    onChange: any;
    countryCode: string;
    value: string;
}

export const handleEffect = wrap((dispatch: DispatchAny, countryCode: string) => {
    dispatch(getTargetAgeOptionsAction({
        countryCode
    }));
});

export const filterTargetAgeByCountry = (targetAgeData: TargetAgeCountryItem[], countryCode: string) => {
    return targetAgeData.filter((item) => item.countryCode === countryCode)
}

export const mapMenuItems = (item: TargetAgeCountryItem) => {
    const {id, label} = item;

    return (
        <MenuItem value={id} key={id}>
            {label}
        </MenuItem>
    )
};

export const TargetAgeSelect = (props: any) => {
    const {
        value,
        onChange,
        countryCode,
    } = props;
    const dispatch = useDispatch();
    const {isLoading, targetAgeData} = useSelector(selectTargetAge);
    const targetAgeByCountry = filterTargetAgeByCountry(targetAgeData, countryCode);
    const onEffect = handleEffect(dispatch, countryCode);

    useEffect(onEffect, []);

    if (isLoading) {
        return <CircularProgress />;
    }

    return (
        <Select
            className="target-age"
            value={value}
            onChange={onChange}
            variant="filled"
        >
            {targetAgeByCountry.map(mapMenuItems)}
        </Select>
    );
}

export default TargetAgeSelect;
